import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import { SettlementDateAdjustmentContainer } from '../../containers/balance/SettlementDateAdjustmentContainer';
import { BALANCE_PAGE_NAME } from '../../constants/service/app/balanceConstants';

/**
 * 정산 기준일 변경 페이지.
 *
 * 정산아이템의 baseDate/dueDate를 일괄 이동시키는 운영 기능.
 * 탭 2개(변경 작업 실행 / 이력·롤백)로 구성.
 */
const SettlementDateAdjustment = (): React.JSX.Element => {
  return (
    <PageTemplate pageName={BALANCE_PAGE_NAME.BALANCE_DATE_ADJUSTMENT}>
      <SettlementDateAdjustmentContainer />
    </PageTemplate>
  );
};

export default SettlementDateAdjustment;
